module.exports = __webpack_public_path__ + "static/jujubee-header-mobile-19d0728c634608624723f6d8a2b777d9.jpg";